export const environment = import.meta.env.VITE_ENVIRONMENT as 'production' | 'development'
